import { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import cx from 'classnames'

import { CalendarContainer } from '@components/CalendarContainer'
import { CalendarIcon } from '@components/icons/CalendarIcon'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { DateInputProps } from './interface'

const CustomInput = forwardRef(
  (
    {
      className,
      value,
      placeholder,
      calendarIconClassName,
      onClick,
      onBlur,
      onFocus,
    }: any,
    ref: any
  ) => {
    return (
      <button
        className={cx(
          'font-light text-[14px] flex justify-between items-center p-[10px] border border-gray-3 dark:border-purple focus:border-primary rounded-[8px] min-w-[150px] w-full mobile:min-w-[125px] dark:text-dark-10 dark:bg-dark-8',
          className,
          { 'text-secondary-1': !value }
        )}
        type='button'
        onClick={onClick}
        ref={ref}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {value || placeholder}
        <CalendarIcon
          className={calendarIconClassName}
          width='16'
          height='16'
        />
      </button>
    )
  }
)

export function DateInput({
  disabled,
  className,
  isError,
  placeholder,
  actived,
  dataTest,
  ...props
}: DateInputProps) {
  const { isNightOrDarkTheme } = useTheme()
  return (
    <div data-test={dataTest}>
      <DatePicker
        dateFormat='yyyy/MM/dd'
        placeholderText={placeholder}
        customInput={
          <CustomInput
            placeholder={placeholder}
            className={cx({
              className,
              'border-gray-3': !isError && !actived,
              '!border-red-3': isError,
              'bg-gray text-gray-10 border-gray-3': !!disabled,
              'text-secondary': !disabled,
            })}
            calendarIconClassName={cx({ 'text-primary': !disabled })}
          />
        }
        showYearDropdown
        maxDate={new Date()}
        yearDropdownItemNumber={100}
        scrollableYearDropdown
        disabled={disabled}
        popperContainer={CalendarContainer}
        popperClassName={cx({ 'custom-night-mode': isNightOrDarkTheme })}
        {...props}
      />
    </div>
  )
}

DateInput.defaultProps = {
  isError: false,
}
